var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntraserTabLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1024 1024",
    style: {
      enableBackground: "new 0 0 1024 1024"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 512,
    x2: 1024,
    y2: 512,
    gradientTransform: "matrix(6.123234e-17 1 -1 6.123234e-17 1024 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0971CE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    style: {
      stopColor: "#096ECC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5228,
    style: {
      stopColor: "#0764C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7359,
    style: {
      stopColor: "#0553BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9359,
    style: {
      stopColor: "#013BAC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0032A6"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,847.7l0-671.3C0,78.9,78.9,0,176.3,0h671.3C945.1,0,1024,78.9,1024,176.3v671.3 c0,97.4-78.9,176.3-176.3,176.3H176.3C78.9,1024,0,945.1,0,847.7z"
  }))))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M563.6,170.7l-83.2,27.7L170.7,301.7v551.7h551.7l131-393V218v-19.6v-27.7H563.6z M520.3,495l96.5,193.3 c-45.7,30.5-99.4,47.8-156.1,50.3l0.1-243.7L520.3,495z M460.7,467l0-91.2l45.5,91.3L460.7,467z M629.4,713.6l55.8,111.8 l-224.6-0.1l0-58.6C521.6,764.2,579.7,746,629.4,713.6z M652.7,696.9c15.1-11.9,28.9-25.1,41.2-39.3l0,121.7L652.7,696.9z  M639.8,671.2L551.9,495l142,0.1l0,115.6C679.3,633.2,661.2,653.5,639.8,671.2z M538,467.1l-68.6-137.4l224.6,0.1l-0.1,137.3 L538,467.1z M341.2,495l-88,176c-21.3-17.6-39.5-37.8-54-60.2l0-115.8L341.2,495z M199.2,467l0.1-137.3l224.6,0.1L355.1,467 L199.2,467z M240.3,696.6l-41.2,82.5l0-121.7C211.4,671.6,225.2,684.7,240.3,696.6z M263.6,713.4c49.8,32.4,107.8,50.7,168.7,53.3 l0,58.6l-224.6-0.1L263.6,713.4z M276.2,688.2L372.8,495l59.5,0l-0.1,243.7C376.3,736.1,321.3,718.3,276.2,688.2z M386.8,467 l45.6-91.2l0,91.2L386.8,467z M287.8,291.8h424.8l-9.9,9.9H591.4h-27.7H258.2L287.8,291.8z M716.1,288.3H298.3l29.5-9.8h398.1 L716.1,288.3z M782.8,221.6H498.4l29.6-9.8h264.7L782.8,221.6z M779.3,225.1l-9.8,9.8H458.4l29.5-9.8H779.3z M766,238.4l-9.8,9.8 H418.4l29.5-9.8H766z M752.6,251.8l-9.8,9.8H378.3l29.5-9.8H752.6z M739.3,265.1l-9.8,9.8H338.3l29.5-9.8H739.3z M745.9,297.7 v397.4l-9.8,29.5V307.6L745.9,297.7z M749.4,294.2l9.8-9.8v370.7l-9.8,29.5V294.2z M762.7,280.9l9.8-9.8v344l-9.8,29.5V280.9z  M776.1,267.5l9.8-9.8v317.4l-9.8,29.5V267.5z M789.4,254.2l9.8-9.8V535l-9.8,29.6V254.2z M802.7,240.9l9.8-9.8v264l-9.8,29.5 V240.9z M568,198.4h23.3H806l-9.9,9.9H538.4l25.2-8.4L568,198.4z M722.3,460.4v-27.7V321.3l10.2-10.2v424.1l-10.2,30.6V460.4z  M825.6,432.6v23.3l-1.5,4.4l-8.1,24.2v-257l9.5-9.5V432.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntraserTabLogo);
export default __webpack_public_path__ + "static/media/intraser-tab-logo.33be6f5cb3414624ef3cfd423f8b9ef7.svg";
export { ForwardRef as ReactComponent };